/*
  nachin-form-validate.js — Validación de los formularios Nachín (Contacto y Mayorista).

  El modo de cada campo lo decide Liquid y viaja en data-nachin-charset:
    letras       : letras, espacios, tildes, ñ, apóstrofo y guion (O'Higgins,
                   Ramírez-Soto). Sin números y sin el resto de los especiales.
    alfanumerico : lo anterior + números + & y punto (Baby & Co, Ltda.).
    numeros      : solo dígitos 0-9.
    email        : no filtra caracteres; valida el formato usuario@dominio.tld.
    libre        : no hace nada.

  Bloqueo AL ESCRIBIR: se cancela la pulsación en 'beforeinput' para que el carácter
  no permitido no llegue a aparecer. El filtro de 'input' queda como red de seguridad
  para pegado, autocompletado y teclados móviles que no disparan beforeinput.

  REGLA DE ORO: esto NO puede romper el envío del formulario.
    - Si el navegador no soporta las expresiones usadas, el script sale sin tocar nada.
    - Nunca hace preventDefault sobre el submit.
    - Todo va en try/catch: ante cualquier excepción el formulario sigue funcionando.

  Scope: init por sección sobre [data-nachin-cf] (un nodo por section.id), con guard
  en dataset y re-init en shopify:section:load (editor del tema).
*/
(function () {
  'use strict';

  var STRIP = {};

  try {
    // \p{L} letras de cualquier idioma (incluye ñ y vocales con tilde)
    // \p{M} marcas de acento sueltas (algunos teclados componen así)
    // \p{N} números
    // Se aceptan los dos apostrofos: el recto (') y el tipografico (’),
    // porque los teclados de movil suelen insertar el segundo.
    STRIP.letras = /[^\p{L}\p{M} '’\-]/gu;
    STRIP.alfanumerico = /[^\p{L}\p{M}\p{N} '’&.\-]/gu;
    STRIP.numeros = /[^0-9]/g;
  } catch (e) {
    // Navegador sin soporte de \p{...}: no validamos, el formulario queda intacto.
    return;
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var EMAIL_MSG = 'Ingresa un correo electrónico válido, por ejemplo nombre@correo.cl';
  var INVALID_CLASS = 'nachin-cf__input--invalid';

  /* ¿El texto tiene algún carácter que este modo no permite? */
  function hasBlocked(text, re) {
    re.lastIndex = 0;
    return re.test(text);
  }

  /* Limpia el valor conservando la posición del cursor. Red de seguridad. */
  function sanitize(el, re) {
    try {
      var before = el.value;
      re.lastIndex = 0;
      var after = before.replace(re, '');
      if (after === before) return;

      var pos = el.selectionStart;
      var caret;
      if (typeof pos === 'number') {
        re.lastIndex = 0;
        caret = before.slice(0, pos).replace(re, '').length;
      } else {
        caret = after.length;
      }

      el.value = after;
      try { el.setSelectionRange(caret, caret); } catch (e) {}
    } catch (e) {}
  }

  /* Marca el email como inválido para la validación nativa.
     Vacío = no opinamos: de eso se encarga `required`, que no tocamos. */
  function checkEmail(el, paint) {
    try {
      var v = (el.value || '').trim();
      var ok = v === '' || EMAIL_RE.test(v);

      el.setCustomValidity(ok ? '' : EMAIL_MSG);

      if (ok) el.classList.remove(INVALID_CLASS);
      else if (paint) el.classList.add(INVALID_CLASS);
    } catch (e) {}
  }

  function bindFiltered(el, re) {
    // 1) Bloqueo real al escribir: el carácter nunca entra.
    el.addEventListener('beforeinput', function (ev) {
      try {
        // Solo la escritura directa. El pegado se deja pasar y lo limpia 'input',
        // para no descartar de golpe todo lo que la persona pegó.
        if (ev.inputType !== 'insertText') return;
        if (ev.data == null) return;
        if (hasBlocked(ev.data, re)) ev.preventDefault();
      } catch (e) {}
    });

    // 2) Red de seguridad: pegado, autocompletado, teclados predictivos.
    el.addEventListener('input', function () { sanitize(el, re); });

    // 3) Por si el valor llega precargado desde el servidor.
    sanitize(el, re);
  }

  function bind(el) {
    var mode = el.getAttribute('data-nachin-charset');

    if (mode === 'email') {
      el.addEventListener('input', function () { checkEmail(el, false); });
      el.addEventListener('blur', function () { checkEmail(el, true); });
      return;
    }

    var re = STRIP[mode];
    if (re) bindFiltered(el, re);
  }

  function initSection(root) {
    try {
      if (!root || root.getAttribute('data-nachin-cf-ready') === '1') return;
      root.setAttribute('data-nachin-cf-ready', '1');

      var fields = root.querySelectorAll('[data-nachin-charset]');
      for (var i = 0; i < fields.length; i++) bind(fields[i]);
    } catch (e) {}
  }

  function initAll() {
    try {
      var roots = document.querySelectorAll('[data-nachin-cf]');
      for (var i = 0; i < roots.length; i++) initSection(roots[i]);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // El editor del tema reemplaza el DOM de la sección al re-renderizar.
  document.addEventListener('shopify:section:load', initAll);
})();
